import { instance } from '../../../axios/AxiosInstance';

const PATH = 'age-group';

export async function createAgeGroup(body: Record<string, unknown>): Promise<void> {
  await instance.post(PATH, body);
}

export async function updateAgeGroup(body: Record<string, unknown>): Promise<void> {
  await instance.put(PATH, body);
}
